(function () {
	'use strict';
	
	angular.module('smb-app')
		.factory('smbContentTypesSearchDataStore', ['$q', 'smbContentTypesSearchService', ContentTypesSearchDataStore]);
	
	/**
	 * @ngdoc service
	 * @name smb-app.smbContentTypesDataStore
	 * 
	 * @description
	 * Manages the state for the content types configuration.
	 */
	function ContentTypesSearchDataStore($q, smbContentTypesSearchService) {
		var _groupId;
		var _contentTypes;

		return {
			/**
			 * @ngdoc property
			 * @name smbContentTypesDataStore.contentTypes
			 * @propertyOf smb-app.smbContentTypesDataStore
			 * 
			 * @description
			 * All content types that belong to the current content type group.
			 */
			get contentTypes() {
				return _contentTypes;
			},

			/**
			 * @ngdoc method
			 * @name smbContentTypesDataStore.getContentTypes
			 * @methodOf smb-app.smbContentTypesDataStore
			 * 
			 * @description
			 * Loads and returns all content types for a specific content type group by group id.
			 * 
			 * @param {Number} groupId The content type group id
			 * 
			 * @returns {Deferred} A promise that resolves to a collection of content types.
			 */
			getContentTypes: getContentTypes
		};	

		function getContentTypes(groupId) {
			if (!groupId) {
				return $q.resolve(_contentTypes);
			} else {
				return smbContentTypesSearchService.getContentTypes(groupId)
					.then(function (types) {
						_contentTypes = types;
						_groupId = groupId;
						return types;
					});
			}
		}

	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/dataStores/contentTypesSearchDataStore.js
// module id = 116
// module chunks = 1